/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return async function onChange(value, change) {
    localStorage.setItem('number_of_tabs_to_show', value.number_of_tabs_to_show)
  }
}
